var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0924 6.21678L7.78319 0.907571C7.35063 0.475145 6.64945 0.475145 6.2169 0.907571L0.907693 6.21733C0.475268 6.64989 0.475268 7.35106 0.907693 7.78362L6.2169 13.0923C6.64945 13.5247 7.35063 13.5247 7.78319 13.0923L13.0924 7.78362C13.3002 7.57587 13.417 7.29405 13.417 7.0002C13.417 6.70634 13.3002 6.42452 13.0924 6.21678ZM6.41673 4.01033C6.41673 3.72844 6.6779 3.49992 7.00006 3.49992C7.32223 3.49992 7.58339 3.72844 7.58339 4.01033V7.07283C7.58339 7.35473 7.32223 7.58325 7.00006 7.58325C6.6779 7.58325 6.41673 7.35473 6.41673 7.07283V4.01033ZM7.02981 10.4999H7.01348C6.53561 10.4981 6.1441 10.1199 6.12567 9.64242C6.11701 9.41142 6.20166 9.18666 6.36055 9.01877C6.51944 8.85088 6.7392 8.75399 6.97031 8.74992H6.98665C7.46475 8.75115 7.85661 9.12963 7.87446 9.60742C7.88311 9.83841 7.79846 10.0632 7.63957 10.2311C7.48068 10.399 7.26093 10.4958 7.02981 10.4999Z",
    fill: "#085685"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDiamond);
export default __webpack_public_path__ + "static/media/alert-diamond.6de1e6e5.svg";
export { ForwardRef as ReactComponent };